const BASE = "LoginLocators"

export const LOGIN_LOCATORS = {
  root: `${BASE}.root`,
  emailInput: `${BASE}.emailInput`,
  passwordInput: `${BASE}.passwordInput`,
  loginButton: `${BASE}.loginButton`,
}
